import Wizard, { WizardStepConfig } from "@/components/shared/Wizard/Wizard";
import UsernameStep from "./UsernameStep";
import { useNavigate } from "react-router-dom";
import ShowPasswordStep from "./ShowPasswordStep";
import ConfirmPhraseForgotStep from "./ConfirmPhraseForgotStep";

export default function ForgotPasswordWizard() {
  const navigate = useNavigate();
  const steps: WizardStepConfig[] = [
    {
      name: "Username",
      dataKey: "userData",
      component: UsernameStep,
    },
    {
      name: "RecoveryPhrase",
      dataKey: "password",
      component: ConfirmPhraseForgotStep,
    },
    {
      name: "ShowPassword",
      dataKey: "showPassword",
      component: ShowPasswordStep,
    },
  ];

  return <Wizard steps={steps} onClose={() => navigate("/login")} />;
}
